import { Dialog, Transition } from "@headlessui/react"
import { Fragment } from "react"
import RecycleOutline from "../../../../../../components/svg/RecycleOutline"
import { AiOutlineCloseCircle } from "react-icons/ai"

export default function DeleteAssignment({
  isOpen,
  setIsOpen,
  deleteAssignment
}) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        onClose={() => setIsOpen(false)}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className="w-[320px] transform overflow-hidden rounded-2xl bg-white 
                  py-10 shadow-xl transition-all  sm:w-[485px] "
              >
                <div
                  className="absolute top-0 right-0 cursor-pointer p-4 text-neutral-1"
                  onClick={() => setIsOpen(false)}
                >
                  <AiOutlineCloseCircle size={28} />
                </div>
                <div className="curriculum-scroll no-scroll-track ml-auto mr-2 w-11/12 pr-4 sm:mr-4 sm:w-10/12 sm:pr-16">
                  <div className="flex justify-center">
                    <RecycleOutline />
                  </div>
                  <span className="flex pt-7 text-[20px] font-[500] text-neutral-1">
                    Are you sure you want to delete this assignment?
                  </span>

                  <div className="flex justify-center gap-8 pt-[43px]">
                    <button
                      className={`flex w-[121px] items-center justify-center self-center rounded-[8px] bg-neutral-5 py-3 px-5 font-[400] text-neutral-1`}
                      onClick={() => setIsOpen(false)}
                    >
                      <span className="body-2">Cancel</span>
                    </button>
                    <button
                      className={`flex w-[121px] items-center justify-center self-center rounded-[8px] bg-danger py-3 px-5 font-[400] text-white`}
                      onClick={() => {
                        deleteAssignment()
                        setIsOpen(false)
                      }}
                    >
                      <span className="body-2">Delete</span>
                    </button>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
